<template>
  <vx-card :title="title">
    <div v-show="visibleRes">
      <Actions
        @closeReport="closeReport"
        @downloadPdf="downloadPdf"
      />
      <template v-if="result.length">
        <div ref="contentPdf">
          <div v-for="(item,i) in result" :key="i">
            <div class="text-2xl font-bold text-red-400 my-5">{{
                item[groupByFilters(form.getFieldValue('group_by'))]
              }}
            </div>
            <a-table :dataSource="item.matters" :columns="columns" :pagination="false" >
              <span slot="description" slot-scope="text,record">
                {{ limitTextTask(record.description) }}
              </span>
              <div slot="client" slot-scope="text,record">
                <template v-if="record.client.person">{{ record.client.person.first_name }}
                  {{ record.client.person.last_name }}
                </template>
                <template v-else>{{ record.client.company.name }}</template>
              </div>
              <div slot="emails" slot-scope="text,record">
                <ATag v-for="email in record.client.emails">
                  {{ email.email_address }}
                </ATag>
              </div>
              <div slot="phones" slot-scope="text,record">
                <ATag v-for="phone in record.client.phones">
                  {{ phone.phone_number }}
                </ATag>
              </div>
            </a-table>
          </div>
        </div>
      </template>
      <template v-else>
        <a-empty/>
      </template>
    </div>
    <div v-show="!visibleRes">
      <a-form :form="form" @submit.prevent="handleReport">
        <div class="grid grid-cols-1 w-full md:w-1/2">
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Responsible Lawyer">
              <a-radio-group
                v-decorator="['which_responsible',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]"
                @change="handleChangeResponsible">
                <a-radio :style="radioStyle" :value="1">
                  All Responsible Lawyers
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Responsible Lawyer
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <SelectOption
              v-show="responsible_value === 2"
              url="/account/list/"
              label="User"
              field="responsible"
              :required="false"
              method="get"
              placeholder="Find A User"
              mode="multiple"
              class="w-full self-end"
            />
          </div>
          <SelectOption url="/dictionary/practice-area/" label="Practice Area" placeholder="Practice Area"
                        field="practice_area" method="get"/>
          <a-form-item label="Group Results By">
            <a-select v-decorator="['group_by',{initialValue: 1,rules: [{ required: false }] }]">
              <a-select-option :value="1">
                Client
              </a-select-option>
              <a-select-option :value="2">
                Responsible Lawyer
              </a-select-option>
              <a-select-option :value="3">
                Owner
              </a-select-option>
              <a-select-option :value="4">
                Practice Area
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-checkbox v-decorator="['include_pending']">Include Pending Matter</a-checkbox>
          </a-form-item>
          <a-form-item>
            <a-checkbox v-decorator="['include_closed']">Include Closed Matter</a-checkbox>
          </a-form-item>
        </div>
        <BtnSubmitReport
          ref="reportSubmit"
          @backPage="$emit('changeTab','MatterReport')"
        />
      </a-form>
    </div>
    <ExportPdf
      ref="exportPdf"
      :title="title"
      @onProgress="onProgress"
      @hasDownloaded="hasDownloaded"
    >
      <div id="pdf"></div>
    </ExportPdf>
  </vx-card>
</template>

<script>

import SelectOption from '../../forms/SelectOptionSingle'
import selectSearch from '../../forms/selectSearch'
import axios from '@/axios'
import mixin from '../../mixin/mixin'
import Actions from "@/components/closeDownloadReport/Actions";
import ExportPdf from "@/components/pdf/ExportPdf";
import BtnSubmitReport from "@/components/btn-report-submit/BtnSubmitReport";

const columns = [
  {
    title: 'Matter',
    dataIndex: 'title',
    key: '1',
  },
  {
    title: 'Client',
    dataIndex: 'client',
    key: '2',
    scopedSlots: {customRender: 'client'},
  },
  {
    title: 'Primary Phone Number',
    dataIndex: 'phone_number',
    key: '3',
    scopedSlots: {customRender: 'phones'},
  },
  {
    title: 'Primary Email Address',
    dataIndex: 'email_address',
    key: '4',
    scopedSlots: {customRender: 'emails'},
  },
]

export default {
  name: "ComponentGeneral",
  mixins: [mixin],
  components: {
    BtnSubmitReport,
    Actions,
    ExportPdf,
    SelectOption,
    selectSearch
  },
  data() {
    return {
      responsible_value: null,
      title:'Contact Information',
      columns,
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '30px',
      },
    }
  },
  methods: {
    handleChangeResponsible({target: {value}}) {
      if (value === 1)
        this.form.setFieldsValue({ responsible: [] })
      this.responsible_value = value
    },
    handleReport() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.$refs.reportSubmit.loading = true
            const query = []
            if (values.include_pending) query.push({field: 'status', condition: '=', value: 3 , not: true, operation: 'and'})
            if (values.include_closed) query.push({field: 'status', condition: '=', value: 2, not: true, operation: 'and'})
            if (values.responsible && values.responsible.length) query.push({
              field: 'responsible__id',
              condition: 'in',
              value: values.responsible,
              operation: 'and'
            })
            if (values.practice_area) query.push({
              field: 'practice_area',
              condition: '=',
              value: values.practice_area,
              operation: 'and'
            })
            const {data} = await axios.post('matter/report/matters', {
              group_by: values.group_by,
              query: query.length ? query : undefined,
              responsible: values.responsible && values.responsible.length ? values.responsible : undefined
            })
            this.visibleRes = true
            this.result = Object.values(data)
          } catch (e) {
            this.visibleRes = false
            this.$message.error('Server Error')
            throw new Error(e)
          } finally {
            this.$refs.reportSubmit.loading = false
          }
        }
      })
    },
    groupByFilters(group) {
      if (group === 1) return 'contact'
      if (group === 2) return 'responsible'
      if (group === 3) return 'owner'
      if (group === 4) return 'practice_area'
    },
  }
}
</script>

<style>
@import "../../style/style.css";
</style>
